import { NativeExtensions } from '@wix/thunderbolt-components-native'
import { compCssMappers } from './compCssMappersCompNode'

export const compSelectorToCssMappers = (nativeExtensions: NativeExtensions) => {
	return compCssMappers(nativeExtensions, 'compSelectorToCssMappers')
}
